import React from 'react';
import { Button, Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

interface PricingPlan {
  name: string;
  price: number;
  priceOff: number | undefined;
  period: string | undefined;
  suitable: string;
  features: string[];
  addOnPackage: string[];
  buttonText: string;
  highlighted: boolean;
  isFree: boolean;
}

interface PricingListProps {
  plans: PricingPlan[];
  handleOpenModal: (planName: string) => void;
}

const PricingList: React.FC<PricingListProps> = ({ plans, handleOpenModal }) => (
  <div className="p-pricingPlan_grid">
    {plans.map((plan, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className={mapModifiers('p-pricingPlan_card', plan.highlighted && 'highlighted')}>
        <Typography.Text fontweight="600" extendClasses="p-pricingPlan_name fs-20x24">{plan.name}</Typography.Text>
        <div className="p-pricingPlan_priceContainer">
          {!plan.isFree ? (
            <Typography.Heading type="h4" fontweight="700" extendClasses="p-pricingPlan_price fs-28x33">
              {plan.price !== 0 ? `${plan.price.toLocaleString()}` : 'Let\'s talk'}
            </Typography.Heading>
          ) : (
            <Typography.Heading type="h4" fontweight="700" extendClasses="p-pricingPlan_price fs-28x33">{plan.period}</Typography.Heading>
          )}
          {plan.priceOff !== 0 && (
            <Typography.Text extendClasses="p-pricingPlan_priceOff">
              {plan.priceOff}
            </Typography.Text>
          )}
          {!plan.isFree && <Typography.Text extendClasses="p-pricingPlan_period fs-14x18">{plan.period}</Typography.Text>}
        </div>
        <div className="p-pricingPlan_buttonContainer">
          <Button onClick={() => handleOpenModal(plan.name)} extendClasses={mapModifiers('p-pricingPlan_button', plan.highlighted && 'highlighted')}>{plan.buttonText}</Button>
        </div>
        <div className="p-pricingPlan_description"><Typography.Text extendClasses="fs-14x18">{plan.suitable}</Typography.Text></div>
        <div className="p-pricingPlan_featuresContainer">
          <Typography.Text fontweight="600" extendClasses="p-pricingPlan_featuresTitle fs-14x18">
            What
            {'\''}
            s included
          </Typography.Text>
          <ul className="p-pricingPlan_features">
            {plan.features.map((feature, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className="p-pricingPlan_feature" key={idx}>
                <Icon iconName="checkLightGreen" size="24" />
                <Typography.Text extendClasses="p-pricingPlan_featureText fs-14x18">{feature}</Typography.Text>
              </li>
            ))}
          </ul>
        </div>
        <div className="p-pricingPlan_featuresContainer">
          <Typography.Text fontweight="600" extendClasses="p-pricingPlan_featuresTitle fs-14x18">Available add-ons for purchase:</Typography.Text>
          <ul className="p-pricingPlan_features">
            {plan.addOnPackage.map((feature, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className="p-pricingPlan_featureAddOn" key={idx}>
                <Icon iconName="starFour" size="24" />
                <Typography.Text extendClasses="p-pricingPlan_featureText fs-14x18">{feature}</Typography.Text>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
);

export default PricingList;
